// Replaces bootstrap-vue's $bvModal with the only two methods the app uses (pinned by
// __tests__/bootstrap/bModalUsage.test.js): show(id) and hide(id).
// Every mounted BModal registers itself here under its id. Several modals may share an id (e.g. the akt options
// popup mounted by a table row and by the payment modal); bootstrap-vue's root events reached all of them, so
// show / hide still do.
const modals = new Map()

export const registerModal = (id, modal) => {
  if (!modals.has(id)) modals.set(id, new Set())
  modals.get(id).add(modal)
}

export const unregisterModal = (id, modal) => {
  const set = modals.get(id)
  if (!set) return
  set.delete(modal)
  if (!set.size) modals.delete(id)
}

// copies, because a hide handler may unmount a modal (FormModal) and unregister it meanwhile
const each = (id, fn) => [...(modals.get(id) || [])].forEach(fn)

export const bvModal = {
  show(id) {
    each(id, modal => modal.show())
  },
  hide(id) {
    each(id, modal => modal.hide('event'))
  }
}
